{
  "__comment.error.app": "Erreurs générées dans l'app - weblate: copier-coller sans traduire cette ligne",
  "__comment.error.backend": "Erreurs générées depuis le backend - weblate: copier-coller sans traduire cette ligne",
  "admin.unauthorized": "",
  "anonymous.request": "",
  "app-service.not-connected": "",
  "app-service.unavailable.description": "Problem z połączeniem uniemożliwia dostęp do usługi. Proszę sprawdzić swoje połączenie sieciowe. Dziękujemy za cierpliwość!",
  "app.accessibility.community": "",
  "app.accessibility.intentions": "",
  "app.accessibility.intentions-theme": "",
  "app.accessibility.messages": "",
  "app.accessibility.unsubscribe-donation-mail": "",
  "app.audio.listen": "",
  "app.audio.loading-error": "",
  "app.avoidance-navigation.content": "",
  "app.banner.goal.goal": "",
  "app.description": "",
  "app.donation.later.i-want": "",
  "app.donation.later.success.toast": "",
  "app.download": "",
  "app.error": "",
  "app.how-to.open-menu": "",
  "app.i-donate": "",
  "app.maintenance": "<strong>Hozana</strong> jest w trakcie konserwacji.\nOdczekaj kilka minut przed odświeżeniem przeglądarki, aby kontynuować.",
  "app.navigation.events-link": "Spotkania Hozana!",
  "app.navigation.footer.faq.link": "Pytania... i odpowiedzi!",
  "app.navigation.footer.guide.all": "Wszystkie artykuły z naszych przewodników",
  "app.navigation.footer.guide.bible": "Odkryj Biblię",
  "app.navigation.footer.guide.catechism": "",
  "app.navigation.footer.guide.feast-days": "Święta chrześcijańskie",
  "app.navigation.footer.guide.meditation": "",
  "app.navigation.footer.guide.miracles": "",
  "app.navigation.footer.guide.prayer": "Wskazówki dotyczące modlitwy",
  "app.navigation.footer.guide.rosary": "",
  "app.navigation.footer.guide.saints": "Odkryj świętych",
  "app.navigation.footer.who.we.are.link": "Kim jesteśmy?",
  "app.navigation.jobs-link": "Oferty pracy",
  "app.navigation.main": "",
  "app.navigation.open-menu": "",
  "app.navigation.secondary": "",
  "app.report-abuse.comment": "",
  "app.report-abuse.intention": "",
  "app.report-abuse.placeholder": "",
  "app.report-abuse.reason": "",
  "app.report-abuse.report": "",
  "app.report-abuse.send": "",
  "app.report-abuse.uplift": "",
  "app.report-issue.button": "",
  "app.report-issue.thank-you": "",
  "auth.login.email": "Zaloguj się przez e-mail",
  "auth.login.login": "Zaloguj się",
  "auth.otp.code.accessibility-label": "Sześciocyfrowy kod uwierzytelniający",
  "auth.otp.code.description": "Wysłaliśmy tymczasowy kod na adres: {email}",
  "auth.otp.code.resend": "Wyślij kod ponownie",
  "auth.otp.code.title": "Sprawdź pocztę",
  "auth.otp.login.title": "Jaki jest Twój adres e-mail?",
  "auth.otp.signup.title": "Jak masz na imię?",
  "auth.privacy.notice": "Hozana jest bezpłatna. Zapoznaj się z <link>warunkami korzystania</link>. Hozana nigdy nie udostępni Twojego adresu e-mail osobom trzecim bez Twojej zgody.",
  "auth.signup.signup": "",
  "auth.social.apple": "Zaloguj się przez Apple",
  "auth.social.apple.missing-identity-token": "Logowanie przez Apple nie zwróciło tokenu tożsamości",
  "auth.social.google": "",
  "auth.social.google.canceled": "Logowanie przez Google zostało anulowane",
  "auth.social.google.missing-authorization-code": "Logowanie przez Google nie zwróciło kodu autoryzacyjnego",
  "birthdate.invalid": "",
  "captcha.invalid": "",
  "captcha.missing": "",
  "captcha.required": "",
  "comment.community.unknown": "",
  "comment.delete.delete": "",
  "comment.delete.fail.none": "",
  "comment.delete.not.found": "",
  "comment.form.empty": "",
  "comment.id.not-found": "",
  "comment.not-found": "",
  "comment.relative.time": "",
  "comment.relative.time.today": "",
  "comment.relative.time.week-day": "",
  "comment.relative.time.yesterday": "",
  "comment.relative.week-day": "",
  "comment.update.not.found": "",
  "comment.write.your-comment": "",
  "common.error.api.default": "",
  "common.error.unknown": "",
  "common.form.error.captcha.invalid": "",
  "common.form.error.captcha.required": "",
  "common.form.error.email.invalid": "",
  "common.form.error.fail": "",
  "common.form.error.field.invalid": "",
  "common.form.error.field.required": "",
  "common.form.error.message.required": "",
  "common.form.error.password-is-name": "",
  "common.form.error.password.different": "",
  "common.form.error.subject.required": "",
  "common.word.start-today": "",
  "common.word.start-tomorrow": "",
  "common.word.tomorrow": "",
  "communities.categories": "",
  "communities.categories.all": "",
  "communities.for-you.edit": "",
  "communities.for-you.empty": "",
  "communities.for-you.settings": "",
  "communities.other-suggestions": "",
  "communities.search": "",
  "communities.see-more": "",
  "community.activity.inactive": "",
  "community.all": "Wszystkie grupy",
  "community.already-exists": "",
  "community.communities.suggested": "",
  "community.communities.team-favorite": "",
  "community.communities.view-all": "",
  "community.creation.suggestion": "",
  "community.date.from-to": "",
  "community.description.prayer.success": "Dziękujemy za twoją modlitwę!",
  "community.description.read-more": "",
  "community.everlasting.unavailable-program": "",
  "community.join-mails.activation": "",
  "community.join-mails.subtitle": "",
  "community.join-mails.title": "",
  "community.join-next.everlasting.start": "",
  "community.join-next.no-publication.start": "",
  "community.join-next.pray-now": "",
  "community.join-next.start": "",
  "community.join-next.start-later": "",
  "community.join.card.button": "",
  "community.join.confirmation.in-progress": "",
  "community.join.confirmation.soon": "",
  "community.join.confirmation.today": "",
  "community.join.congrats": "",
  "community.join.congrats.comingSoon": "",
  "community.join.congrats.ongoing": "",
  "community.join.congrats.startToday": "",
  "community.join.date": "",
  "community.join.date.validate": "",
  "community.join.error.no-subscription": "",
  "community.join.from-date": "",
  "community.join.infos": "",
  "community.join.invalid-schedule-date": "",
  "community.join.not-schedulable": "",
  "community.join.options.title": "",
  "community.join.scheduled-end-date.novena": "",
  "community.join.scheduled-end-date.retreat": "",
  "community.join.success.message": "",
  "community.leave-community": "",
  "community.leave.already.left": "",
  "community.leave.confirm": "",
  "community.leave.fail": "",
  "community.leave.success": "",
  "community.load.error": "",
  "community.not-found": "",
  "community.not-joined": "",
  "community.notifications.activate-push": "",
  "community.notifications.receive-publications-push": "",
  "community.notifications.receive-publications-push.subtitle": "",
  "community.private.private": "",
  "community.publication.error.publication.not-accessible": "",
  "community.role.administrator.long": "",
  "community.role.animator.long": "",
  "community.role.creator.long": "",
  "community.share.text": "",
  "community.status.check.validating": "",
  "community.status.draft.word": "",
  "community.tab.description": "",
  "community.toolbar.community": "",
  "community.toolbar.stop": "",
  "community.toolbar.title": "",
  "community.unavailable-program": "",
  "community.unmodifiable": "",
  "communityAnnouncement.community.user.not-allowed": "",
  "communityAnnouncement.message.too-long": "",
  "communityAnnouncement.subject.too-long": "",
  "contact.captcha_v2.title": "",
  "contact.email.invalid": "",
  "contact.firstname.invalid": "",
  "contact.firstname.placeholder": "",
  "contact.firstname.tooLong": "",
  "contact.lastname.invalid": "",
  "contact.lastname.label": "",
  "contact.lastname.placeholder": "",
  "contact.load.error": "",
  "contact.message.alert": "",
  "contact.message.invalid": "",
  "contact.message.label": "",
  "contact.message.tooShort": "",
  "contact.send-message": "",
  "contact.subject.invalid": "",
  "contact.subject.label": "",
  "contact.subject.placeholder": "",
  "contact.subtitle": "",
  "contact.success.toast": "",
  "content.forbidden-content": "",
  "content.invalid": "",
  "content.invalid-contain-email": "",
  "content.invalid-contain-url": "",
  "content.required": "",
  "content.too-long": "",
  "content.too-short": "",
  "conversation.ambiguous-definition": "",
  "conversation.block": "",
  "conversation.few-seconds": "",
  "conversation.mark-as-unread": "",
  "conversation.not-found": "",
  "conversation.unblock": "",
  "conversation.user.not-allowed": "",
  "conversation.you-blocked": "",
  "conversations.unread": "",
  "cta.share": "",
  "dates.invalid": "",
  "description.forbidden-content": "",
  "description.invalid": "",
  "description.required": "",
  "description.too-long": "",
  "description.too-short": "",
  "device.delete.not.found": "",
  "draft.conflict": "",
  "email.already-exists": "",
  "email.invalid": "",
  "email.user.not-found": "",
  "error.403.title": "",
  "error.404.message": "Znajdź grupy, które mogą pomóc ci w modlitwie",
  "error.404.quote": "Szukajcie Pana, gdy się pozwala znaleźć,\nwzywajcie Go, dopóki jest blisko!\n(Iz 55, 6)",
  "error.404.title": "Przepraszamy, ta strona nie istnieje…",
  "favorite.not-found": "",
  "file.not-an-image": "",
  "fraternity.gender.question": "",
  "fraternity.gender.title": "",
  "fraternity.join.already-have": "",
  "fraternity.join.already-have-description": "",
  "fraternity.join.find": "",
  "fraternity.join.find-description": "",
  "fraternity.join.subtitle": "",
  "fraternity.join.title": "",
  "fraternity.lead.accept": "",
  "fraternity.lead.decline": "",
  "fraternity.lead.description": "",
  "fraternity.lead.learn-more": "",
  "fraternity.lead.title": "",
  "fraternity.onboarding.close.body": "",
  "fraternity.onboarding.close.footer": "",
  "fraternity.onboarding.close.title": "",
  "fraternity.place.city-label": "",
  "fraternity.place.hint": "",
  "fraternity.place.nearby": "",
  "fraternity.place.nearby-description": "",
  "fraternity.place.remote": "",
  "fraternity.place.remote-description": "",
  "fraternity.place.title": "",
  "fraternity.presentation.item.encourage": "",
  "fraternity.presentation.item.pray": "",
  "fraternity.presentation.item.share": "",
  "fraternity.presentation.subtitle": "",
  "fraternity.presentation.title": "",
  "fraternity.ready.eager-no": "",
  "fraternity.ready.eager-yes": "",
  "fraternity.ready.subtitle": "",
  "fraternity.ready.title": "",
  "fraternity.recap.cta": "",
  "fraternity.recap.lead": "",
  "fraternity.recap.place": "",
  "fraternity.recap.sex": "",
  "fraternity.recap.subtitle": "",
  "fraternity.recap.title": "",
  "fraternity.step-label": "",
  "fromDate.in-the-futur": "",
  "fromDate.in-the-past": "",
  "getCommunitiesJoined.user.not-found": "",
  "getCommunitiesWithRole.user.not-found": "",
  "getCommunityNotifications.subscriptionId.not-found": "",
  "guestName.required": "",
  "guestName.too-long": "",
  "guide.not-found": "",
  "hash.invalid": "",
  "hash.required": "",
  "home.faq.title.head": "Jak to działa?",
  "home.welcome.app-section.title": "",
  "home.welcome.intentions.title": "Pozostaw swoje intencje, \nmódl się za innych",
  "iframe.error.description": "",
  "iframe.error.title": "",
  "intention.anonymous-praying": "",
  "intention.answer.uplift": "",
  "intention.arrival.just-joined": "",
  "intention.arrival.welcome-pray": "",
  "intention.birthday.celebration": "",
  "intention.birthday.pray": "",
  "intention.birthday.years-old": "",
  "intention.created.description": "",
  "intention.created.success": "Twoja intencja została złożona",
  "intention.delete.confirm-message1": "",
  "intention.delete.confirm-message2": "",
  "intention.delete.delete": "",
  "intention.finished.arrival": "",
  "intention.finished.birthday": "",
  "intention.finished.intention": "",
  "intention.finished.prayers": "",
  "intention.finished.thank": "",
  "intention.from": "",
  "intention.invitation-to-pray-for": "{name} poleca tę intencję twoim modlitwom.",
  "intention.load.error": "",
  "intention.not-found": "",
  "intention.page.button": "",
  "intention.pray-for": "",
  "intention.prayed.already": "",
  "intention.prayed.already-with": "",
  "intention.prayed.birthday": "",
  "intention.prayed.by": "{count, plural, =0 {Nikt jeszcze nie modlił się} =1 {{name} już się pomodlił} =2 {{otherNames} i {name} już się pomodlili} =3 {{otherNames} i {name} już się pomodlili} =4 {{otherNames}, {name} i jeszcze jedna osoba już się pomodlili} other {{otherNames}, {name} i {remainingCount} innych osób już się pomodlili}} za tę intencję",
  "intention.prayed.pray-for-others": "👉🏻 Czy chciałbyś pomodlić się za inne intencje?",
  "intention.prayed.thanks": "",
  "intention.prayed.with": "🙏 {count} {count, plural, one {osoba pomodliła się} few {osoby pomodliły się} many {osób pomodliło się} other {osób pomodliło się}} razem z tobą za tę intencję",
  "intention.prayer.not-found": "",
  "intention.prayer.watchman.activate-notifications": "",
  "intention.prayer.watchman.became-watchman": "",
  "intention.prayer.watchman.become": "",
  "intention.prayer.watchman.engagement.1": "",
  "intention.prayer.watchman.fetching": "",
  "intention.prayer.watchman.join": "",
  "intention.prayer.watchman.many-watchmen": "",
  "intention.prayer.watchman.method-reminder": "",
  "intention.prayer.watchman.pray-support": "",
  "intention.prayer.watchman.reminder.by-email": "",
  "intention.prayer.watchman.reminder.by-notification": "",
  "intention.prayers.list.title": "",
  "intention.publish.button": "",
  "intention.reload": "",
  "intention.share": "",
  "intention.time-left": "",
  "intention.title": "",
  "intention.write.here": "",
  "intentions.not-found": "",
  "intentions.title": "",
  "intentions.view": "Zobacz intencje",
  "introduction.forbidden-content": "",
  "introduction.too-long": "",
  "introduction.too-short": "",
  "joinCommunity.community.join.already-finished-community": "",
  "journey.empty.active": "Nie masz żadnego trwającego programu.",
  "journey.novenas-and-journeys": "Nowenny i programy",
  "journey.prayed.today": "Odmówiono dzisiaj",
  "journey.see-history": "Historię",
  "lang.unsupported": "",
  "language.en": "",
  "language.es": "",
  "language.fr": "",
  "language.it": "",
  "language.pl": "",
  "language.pt": "",
  "leave.confirm.message": "",
  "leave.guides-title": "",
  "leave.pray-differently": "",
  "leave.sign-up-again": "",
  "login.account.disabled": "",
  "login.account.missing": "",
  "login.code-input.check-email": "Sprawdź kod otrzymany e-mailem",
  "login.code.required": "Kod jest wymagany",
  "login.csrf.invalid": "Sesja wygasła, spróbuj ponownie",
  "login.email.invalid": "Nieprawidłowy adres e-mail",
  "login.email.not-provided": "",
  "login.email.required": "",
  "login.failed": "Kod jest nieprawidłowy lub wygasł",
  "login.password.required": "",
  "meeting.organizer.place.name-placeholder": "",
  "meeting.organizer.time-invalid": "",
  "meeting.organizer.timeStart-invalid": "",
  "message.automatic-message": "",
  "message.delete": "",
  "message.delete.user.not_allowed": "",
  "message.deleted": "",
  "message.godfather.welcome-message.to-godfather": "",
  "message.godfather.welcome-message.to-godson": "",
  "message.invalid": "",
  "message.list.title": "",
  "message.list.title.conversation": "",
  "message.list.title.cta": "",
  "message.list.title.intention": "",
  "message.prayer-on-arrival.has-thanked-you": "",
  "message.prayer-on-arrival.you-thanked-for": "",
  "message.prayer-on-birthday.has-thanked-you": "",
  "message.prayer-on-birthday.you-thanked-for": "",
  "message.prayer-on-comment.has-prayed-for-you": "",
  "message.prayer-on-comment.you-prayed-for": "",
  "message.prayer-on-intention.thank-you": "",
  "message.prayer-on-intention.thanked-you": "",
  "message.prayer.has-just-prayed-for-you.short-multiple": "",
  "message.prayer.has-just-prayed-for-you.short-single": "",
  "message.prayer.has-prayed-for-you.long": "",
  "message.prayer.you-prayed-for.long": "",
  "message.reported": "",
  "message.suspicious.received": "",
  "message.suspicious.sent": "",
  "message.textarea.help.return": "",
  "message.unselected": "",
  "message.update.user.not_allowed": "",
  "name.exists": "",
  "name.forbidden-content": "",
  "name.invalid": "Nieprawidłowe imię",
  "name.required": "",
  "name.too-long": "",
  "name.too-short": "",
  "native.push.how-to.reactivate.description": "Kliknij „Tak, włączam powiadomienia”, a przekierujemy Cię do ustawień iPhone’a. Włącz opcję „Powiadomienia”, a następnie naciśnij strzałkę wstecz ⬅️ u góry, aby wrócić.",
  "navigation.confession-link": "Spowiadać się",
  "navigation.guides.title": "",
  "navigation.intentions": "",
  "navigation.live-page-link": "Msze i modlitwy na żywo",
  "navigation.search": "",
  "notificationEmail.invalid": "",
  "oldPassword.invalid": "",
  "page.gone": "",
  "page.not-found": "",
  "password.required": "",
  "password.too-long": "",
  "payload.bad-content": "",
  "payload.text-too-long": "",
  "pictureFileId.required": "",
  "postIntention.content.too-long": "",
  "pray.amen": "Amen!",
  "pray.comment.title": "",
  "pray.entrust-intention": "",
  "pray.entrust-intention.body": "",
  "pray.i-pray.short": "Módl się",
  "pray.intention.arrival.title": "Modlisz się za {userName}, który właśnie przybył do Hozana",
  "pray.intention.birthday.title": "To urodziny {userName}",
  "pray.intention.community.show": "",
  "pray.intention.publication.done": "",
  "pray.intention.publication.show": "",
  "pray.intention.show": "A teraz, czy chcesz pomodlić się za intencję {user}?",
  "pray.intention.title": "Modlisz się za intencję {userName}",
  "pray.pray": "",
  "pray.prayed": "",
  "pray.prayer-sent": "",
  "pray.uplift.description": "",
  "pray.uplift.sent": "",
  "pray.uplift.title": "",
  "pray.write-intention": "",
  "pray.your-intention": "",
  "prayer-space.onboarding.step-1.description": "Cały zespół Hozany z radością przedstawia Ci nowy Kącik Modlitwy, który pomoże Ci wzrastać w wierności codziennej modlitwie.",
  "prayer-space.onboarding.step-1.title": "Nowy Kącik Modlitwy!",
  "prayer-space.onboarding.step-2.description": "Z łatwością znajdź nowenny i rekolekcje, w których obecnie uczestniczysz, i sprawdź swoje postępy!",
  "prayer-space.onboarding.step-2.title": "Śledź swoje Nowenny i Rekolekcje",
  "prayer-space.onboarding.step-3.description": "W sekcji „Na co dzień” znajdziesz swoje codzienne modlitwy: Ewangelię na dziś, Liturgię Godzin, modlitwy ze świętym dnia i wiele innych.",
  "prayer-space.onboarding.step-3.title": "Znajdź swoje codzienne modlitwy",
  "prayer-space.onboarding.step-4.description": "W sekcji „To może Cię zainteresować” odkryj aktualne propozycje i wróć do nowenn oraz rekolekcji, którymi lubisz się modlić.",
  "prayer-space.onboarding.step-4.title": "Odkryj bogactwo modlitwy na Hozanie",
  "prayer-space.welcome.discover": "",
  "prayer-space.welcome.end-paragraph": "",
  "prayer-space.welcome.paragraph": "",
  "prayerContent.invalid": "",
  "prayerContent.too-long": "",
  "prayerName.invalid": "",
  "prayerName.required": "",
  "prayerName.too-long": "",
  "prayerSample.not-found": "",
  "publication.already-exists": "",
  "publication.comment.loadmore": "",
  "publication.comment.loadmoreanswers": "",
  "publication.comment.show": "",
  "publication.comment.title": "",
  "publication.favorite.add": "",
  "publication.favorite.remove": "",
  "publication.favorite.removed": "",
  "publication.favorite.success": "",
  "publication.frequency.type.daily": "",
  "publication.frequency.type.long.daily": "",
  "publication.frequency.type.long.monthly": "",
  "publication.frequency.type.long.sporadically": "",
  "publication.frequency.type.long.weekly": "",
  "publication.frequency.type.monthly": "",
  "publication.frequency.type.sporadically": "",
  "publication.frequency.type.weekly": "",
  "publication.goto": "",
  "publication.load.error": "",
  "publication.not-found": "",
  "publication.prayed": "",
  "publication.prayed-by": "",
  "publication.prayed.share.body": "",
  "publication.prayed.share.button": "",
  "publication.prayed.share.choose.body": "",
  "publication.prayed.share.choose.title": "",
  "publication.prayed.share.community.button": "",
  "publication.prayed.share.community.modal.title": "",
  "publication.prayed.share.publication.button": "",
  "publication.prayed.share.publication.modal.title": "",
  "publication.prayed.share.title": "",
  "publication.update": "",
  "publicationFrequencyType.required": "",
  "publicationFrequencyValue.invalid": "",
  "publicationFrequencyValue.required": "",
  "push.allow.message": "",
  "push.blocked.how-to.reactivate": "",
  "push.blocked.how-to.settings.allow": "",
  "push.blocked.how-to.settings.find-hozana": "",
  "push.blocked.how-to.settings.find-list": "",
  "push.blocked.how-to.settings.icon": "",
  "push.blocked.how-to.url-icon.allow": "",
  "push.blocked.how-to.url-icon.browser": "",
  "push.blocked.how-to.url-icon.click": "",
  "push.blocked.message": "",
  "push.blocked.support-link": "",
  "push.blocked.title": "",
  "reportAbuse.reason.required": "",
  "reportAbuse.type.invalid": "",
  "resetPassword.token.invalid": "",
  "role.invalid": "",
  "rosario.bloc.cta": "",
  "rosario.bloc.description.1": "",
  "rosario.bloc.description.2": "",
  "rosario.bloc.description.3": "",
  "rosario.bloc.title": "",
  "rosario.xmrpms.cta": "",
  "rosario.xmrpms.description": "",
  "rosario.xmrpms.objective": "",
  "rosario.xmrpms.title": "",
  "scheduledTime.invalid": "",
  "score-threshold-not-met": "",
  "sendMessage.payload.bad-content": "",
  "settings.account.birthdate": "",
  "settings.account.confirm-password": "",
  "settings.account.current-password": "",
  "settings.account.delete": "",
  "settings.account.delete.confirm": "",
  "settings.account.delete.error-input": "",
  "settings.account.delete.input": "",
  "settings.account.new-password": "",
  "settings.card.community.announce": "",
  "settings.card.community.announce.details": "",
  "settings.card.community.prayer": "",
  "settings.card.notifs.email": "",
  "settings.card.notifs.push": "",
  "settings.email.disable.all": "",
  "settings.header.notifications": "",
  "settings.input.email-is-not-valid": "",
  "settings.input.name-is-not-email": "",
  "settings.input.password.label": "",
  "settings.input.password.social-connect": "",
  "settings.input.title.placeholder": "",
  "settings.language.title": "",
  "settings.notifications.community-registration.title": "",
  "settings.notifications.disable.all": "",
  "settings.notifications.end-of-novena.title": "",
  "settings.notifications.general.description": "",
  "settings.notifications.general.title": "",
  "settings.notifications.incriptions.title": "",
  "settings.notifications.intention-end-time.title": "",
  "settings.notifications.invited-join.title": "",
  "settings.notifications.message.title": "",
  "settings.notifications.newsletter.title": "",
  "settings.notifications.no-ongoing-community.title": "",
  "settings.notifications.pray-remind.title": "",
  "settings.notifications.watchman-remind.title": "",
  "settings.unsubscribe-presubscriber.error": "",
  "settings.unsubscribe-presubscriber.success": "",
  "share.community": "",
  "share.community.share": "",
  "share.copied-link": "",
  "share.copy-link": "",
  "share.intention.email-body": "",
  "share.intention.share": "",
  "share.my.intention.email-body": "",
  "share.publication.email-body": "",
  "share.share": "",
  "share.share-by-email": "",
  "share.share-by-email-body": "",
  "share.wording.send-email": "",
  "share.wording.share-on-whatsapp": "",
  "signup.captcha.required": "",
  "signup.code.invalid": "Kod jest nieprawidłowy lub wygasł",
  "signup.email.exists": "Konto z tym adresem e-mail już istnieje",
  "signup.email.invalid": "",
  "signup.email.required": "",
  "signup.fail": "",
  "signup.name.invalid": "",
  "signup.name.required": "",
  "signup.password.required": "",
  "startConversation.payload.bad-content": "",
  "startConversation.user.not-found": "",
  "tab.discover": "",
  "tab.error.generic-description": "",
  "tab.error.try-again": "",
  "tab.messaging": "",
  "tab.prayer-space": "",
  "tag.not-found": "",
  "timeout-or-duplicate": "",
  "token.expired": "",
  "token.required": "",
  "uplift.answer.error": "",
  "uplift.message": "",
  "user.avatar.logo": "",
  "user.communities": "",
  "user.communities.other": "",
  "user.delivery-issue-email.alert-message": "",
  "user.delivery-issue-email.hard-bounce-invalid": "",
  "user.delivery-issue-email.spam-report": "",
  "user.delivery-issue-email.verify-email": "",
  "user.happy-birthday.psalm": "",
  "user.happy-birthday.reference": "",
  "user.happy-birthday.title": "",
  "user.happy-birthday.users-pray-for-you": "",
  "user.happy-birthday.wish": "",
  "user.home-location": "",
  "user.logout.word": "",
  "user.mail.unsubscribe": "",
  "user.not-found": "",
  "user.popins.avatars.choose-my-image": "",
  "user.profile.done-communities": "",
  "user.profile.favorite-publications": "",
  "user.profile.my-profile": "",
  "user.profile.questions.title.wizard": "",
  "user.profile.questions.you-are": "",
  "user.profile.questions.your-birthdate": "",
  "user.profile.questions.your-location": "",
  "user.settings.click-to-fill": "",
  "user.settings.tab.account.password-required": "",
  "user.title.brother": "",
  "user.title.deacon": "",
  "user.title.family": "",
  "user.title.father": "",
  "user.title.miss": "",
  "user.title.mr": "",
  "user.title.mrs": "",
  "user.title.org": "",
  "user.title.sister": "",
  "user.wizard.audio": "",
  "user.wizard.complete": "",
  "user.wizard.minutes": "",
  "user.wizard.my-wizard": "",
  "user.wizard.novena": "",
  "user.wizard.reading": "",
  "user.wizard.video": "",
  "user.wizard.what-themes": "",
  "user.wizard.what-topics": "",
  "watchman.pray-for-today": "",
  "watchman.prayers.thank-you": "",
  "watchman.rely.remains": "",
  "widget.not-found": "",
  "wizard.communityFormats.unknown": "",
  "wizard.communityTypes.unknown": "",
  "wizard.prayerDuration.unknown": "",
  "wizard.tags.unknown": "",
  "word.all.feminine": "",
  "word.cancel": "",
  "word.characters": "",
  "word.choose": "",
  "word.close": "",
  "word.confirm": "",
  "word.congratulations": "",
  "word.continue": "Kontynuuj",
  "word.days": "",
  "word.edit": "",
  "word.email": "",
  "word.email-address": "",
  "word.email-address-connection": "",
  "word.email-address-notification": "",
  "word.finish": "",
  "word.in": "",
  "word.intentions": "",
  "word.leave-message": "",
  "word.next": "",
  "word.no": "",
  "word.notifications": "",
  "word.notifications.mails": "",
  "word.prayers": "",
  "word.prayers-count": "",
  "word.previous": "",
  "word.remove": "",
  "word.save": "",
  "word.send": "",
  "word.skip": "",
  "word.today": "",
  "word.validate": "",
  "word.watchman": "",
  "word.whats-next": "",
  "word.yes": "",
  "word.yesterday": "",
  "word.you": "",
  "word.your-firstname": "Twoje imię",
  "word.your-title": "",
  "wording.i-share": "",
  "words.a-man": "",
  "words.a-woman": "",
  "words.answer": "",
  "words.by-user": "",
  "words.click-here": "",
  "words.contact-us": "Kontakt",
  "words.done": "",
  "words.home-page": "",
  "words.i-check": "",
  "words.i-subscribe": "Zarejestruj się",
  "words.in-nb-days": "",
  "words.in-nb-days-begin": "",
  "words.nb-days": "{nbDays} {nbDays, plural, one {dzień} few {dni} many {dni} other {dnia}}",
  "words.no-thanks": "",
  "words.no-thanks2": "",
  "words.not-now": "",
  "words.ongoing": "",
  "words.profile": "",
  "words.see": "",
  "words.see-all.plur-fem": "",
  "words.see-all.sing": "",
  "words.terms-of-use": "Warunki użytkowania",
  "words.thank": "",
  "words.thanked": "",
  "words.your-email-address": "",
  "words.your-intention": "",
  "words.your-message": ""
}
